import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import styled, { css } from 'styled-components'
import Input from '@material-ui/core/Input'
import {
  PURPLE_RGB,
  PURPLE,
  RED,
  MAIN_BACKGROUND,
  PRIMARY_TEXT,
  WHITE,
  GRAY_INFO,
  GRAY,
  GRAY2,
  GRAY3,
  MAIN_TEXT,
} from 'constants/colors'
import { Flex } from 'components/common/styles'

export const GeneralStyles = css`
  .MuiTextField-root {
    &.error {
      input {
        border-color: ${RED};
      }
    }

    .MuiInputBase-root {
      &:before,
      &:after {
        display: none;
      }
    }

    input {
      font-size: 14px;
      padding: 8px 12px;
      background: ${MAIN_BACKGROUND};
      border-radius: 8px;
      font-weight: 500;
      border: 1px solid ${MAIN_BACKGROUND};

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .MuiRadio-root,
  .MuiCheckbox-root {
    padding: 3px;
    margin-right: 5px;

    &.Mui-checked:hover,
    &.MuiCheckbox-indeterminate:hover,
    &:hover {
      background: rgba(${PURPLE_RGB}, 0.15);

      svg {
        fill: ${PURPLE};
      }
    }

    &.Mui-checked,
    &.MuiCheckbox-indeterminate {
      color: ${PURPLE};
    }

    svg {
      width: 16px;
      height: 16px;
    }
  }
`

export const SearchField = styled(Input)`
  background: ${MAIN_BACKGROUND};
  color: ${GRAY3};
  padding: 8px 12px;
  border-radius: 8px;
  margin-left: 24px;
  font-size: 14px;
  font-weight: 500;

  input {
    padding: 0;
  }
`

type HeaderType = {
  isNewHeader: boolean
}

export const Header = styled(Flex)<HeaderType>`
  padding: 14px 16px;
  border-bottom: 1px solid ${GRAY_INFO};

  ${({ isNewHeader }) =>
    isNewHeader &&
    css`
      @media (max-width: ${LAPTOP_BREAKPOINT}px) {
        padding: 14px 52px;
      }
    `}
`

export const StyledTableApp = styled(Flex)`
  ${GeneralStyles};

  flex: 1;
  background: ${WHITE};
  color: ${MAIN_TEXT};
  font-size: 14px;
  line-height: 1.4;
  overflow: hidden;

  .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background: ${PURPLE};
    opacity: 1;
  }
`

export const Title = styled.h2`
  font-size: 22px;
  line-height: 30px;
  margin: 0;
  font-weight: 500;

  .btn-back {
    margin-right: 4px;
  }
`

export const Table = styled(Flex)`
  flex: 1;
  width: 100%;
  overflow: hidden;

  .table-wrapper {
    flex: 1;
    overflow-x: auto;
  }

  table {
    width: 100%;
  }

  thead {
    position: sticky;
    top: 0;
    background: ${WHITE};
    z-index: 1;
  }

  tbody {
    tr {
      cursor: pointer;
    }
  }

  td,
  th {
    padding: 12px 16px;
    border-right: 1px solid ${GRAY2};
    border-bottom: 1px solid ${GRAY2};
    color: ${PRIMARY_TEXT};

    svg {
      &:hover {
        path,
        rect {
          stroke: ${PURPLE};
        }
      }
    }
  }

  td[colspan]:not([colspan='1']) {
    text-align: center;
    font-weight: 500;
    color: ${GRAY};
  }

  th {
    padding: 14px 16px;
    font-weight: 500;
    color: ${GRAY};
    cursor: pointer;
    text-align: left;
  }

  .arrow {
    rotate: 180deg;
  }

  .col-small {
    width: 74px;
  }

  .status-col {
    padding: 0 8px 0 5px;
  }
`
